var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BehaviorSubject, Subject } from 'rxjs';
import { UserService } from './user.service';
import { LayerQcService } from './layer-qc.service';
import { CommonFunctionService } from './common-function.service';
import { ActivityService } from './activity.service';
import { AttrIndexService } from './attr-index.service';
import { CommonTableService } from './common-table.service';
import { AppinfoService } from './appinfo.service';
import { CommonModalService } from './common-modal.service';
import * as i0 from "@angular/core";
import * as i1 from "./common-function.service";
import * as i2 from "./activity.service";
import * as i3 from "./appinfo.service";
import * as i4 from "./attr-index.service";
import * as i5 from "./layer-qc.service";
import * as i6 from "./common-modal.service";
import * as i7 from "./common-table.service";
import * as i8 from "./user.service";
var MainDataService = /** @class */ (function () {
    function MainDataService(commonService, activityService, appinfoService, attrIndexService, qcService, modalService, tableService, userService) {
        this.commonService = commonService;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.qcService = qcService;
        this.modalService = modalService;
        this.tableService = tableService;
        this.userService = userService;
        // qcFilterOptions: BehaviorSubject<{
        // 	feat: FilterOption[];
        // 	schema: FilterOption[];
        // 	layer: FilterOption[];
        // }> = new BehaviorSubject({
        // 	feat: null,
        // 	schema: null,
        // 	layer: null
        // });
        this.qcFilterInfo = new BehaviorSubject({
            // isQcFilter: true,
            isCheckAll: false,
            filterOptions: []
        });
        this.schemaFilterInfo = new BehaviorSubject({
            filterOptions: []
        });
        this.schemaDataBS = new BehaviorSubject({
            layerId: null,
            data: []
        });
        // TODO
        this.layerFilterInfo = new BehaviorSubject({
            filterOptions: []
        });
        this.fishboneFilterInfo = new BehaviorSubject({
            allFilterOptions: [],
            selectedLayerFilterOptions: []
        });
        this.fishboneToggleBS = new BehaviorSubject({
            isOn: false
        });
        this.contentMenuItemKeyBS = new BehaviorSubject(null);
        this.schemasDefinedByBS = new BehaviorSubject({
            live: {
                currentDefinedBy: 'standard'
            },
            published: {
                currentDefinedBy: 'standard'
            },
            report: {
                currentDefinedBy: 'standard'
            }
        });
        this.modelBS = new BehaviorSubject('');
        this.modelOptionBS = new BehaviorSubject({
            hasAllFields: true
        });
        this.editRecordsSubject = new Subject();
        this.dataEditableBS = new BehaviorSubject({});
        this.addressManageHintBS = new BehaviorSubject(null);
        // Store the whole data (not sample) with all attributes within the extent within the !!!ATTRIBUTE FILTERS!!!
        // can be used when zoom in with map filter on
        // It's only stored when isStoredDataSample is false, but isDisplaySample could be true
        this.dataIndex = {};
        this.dataIndexObjSubject = new Subject();
        // wholeData: {
        // 	feats?: Feature[];
        // 	rows?: any[];
        // 	extent?: number[];
        // } = {};
        // Store the whole bg data within map filter // NO attribute filter applied
        this.wholeBgData = {};
        // Store the whole bg reference data within map filter // NO attribute filter applied
        this.wholeRefData = {};
        this.wholeBgBdryData = {};
        // Address data label calc
        this.dataLabelCalc = {};
        this.refDataLabelCalc = {};
    }
    MainDataService.prototype.getFilterOptions = function (layerId, isSelected) {
        return __awaiter(this, void 0, void 0, function () {
            var data, featOptions_1, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.qcService.getQaRules(this.userService.selectedCustomer.getValue().id, null, layerId)];
                    case 1:
                        data = _a.sent();
                        featOptions_1 = [];
                        // const schemaOptions: FilterOption[] = [];
                        // const layerOptions: FilterOption[] = [];;
                        data.forEach(function (d) {
                            var obj = {
                                name: d.ruleName,
                                value: d.code,
                                count: d.count,
                                descriptionLong: d.describLong,
                                errorLevel: d.errorLevel,
                                isSelected: isSelected,
                                type: d.type,
                                exceptionAllowed: d.exceptionAllowed
                            };
                            // if (d.scope === 'INTER-LAYER') { return; }
                            // if (d.type === 'FEATURE') {
                            // 	featOptions.push(obj);
                            // } else if (d.type === 'SCHEMA' ) {
                            // 	schemaOptions.push(obj);
                            // } else if (d.type === 'LAYER') {
                            // 	layerOptions.push(obj);
                            // } else {
                            featOptions_1.push(obj);
                            // }
                        });
                        return [2 /*return*/, {
                                feature: featOptions_1
                                // schema: schemaOptions,
                                // layer: layerOptions
                            }];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MainDataService.prototype.getFilterOptions_fishbone = function (layerType) {
        return __awaiter(this, void 0, void 0, function () {
            var cusId, fishboneFilterInfo, selectedLayerFilterOptions, allFilterOptions, all_1, allQaRules;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cusId = this.userService.selectedCustomer.getValue().id;
                        fishboneFilterInfo = this.fishboneFilterInfo.getValue();
                        selectedLayerFilterOptions = [];
                        allFilterOptions = fishboneFilterInfo.allFilterOptions;
                        if (!cusId) return [3 /*break*/, 3];
                        if (!!allFilterOptions.length) return [3 /*break*/, 2];
                        all_1 = [];
                        return [4 /*yield*/, this.qcService.getQaRules(cusId, null, null, null, null, 'code')];
                    case 1:
                        allQaRules = _a.sent();
                        allQaRules.forEach(function (d) {
                            var obj = {
                                name: d.ruleName,
                                value: d.code,
                                // description: d.describShort,
                                descriptionLong: d.describLong,
                                errorLevel: d.errorLevel,
                                isSelected: d.code !== 'FS1' && d.code !== 'FS3',
                                type: d.type
                            };
                            all_1.push(obj);
                        });
                        allFilterOptions = all_1;
                        _a.label = 2;
                    case 2:
                        selectedLayerFilterOptions = allFilterOptions.filter(function (o) { return o.type === layerType; });
                        _a.label = 3;
                    case 3: return [2 /*return*/, selectedLayerFilterOptions];
                }
            });
        });
    };
    MainDataService.prototype.getQaCodesFromFilterOptions = function () {
        // Get qaCodes
        var qaCodes = [];
        this.qcFilterInfo.getValue().filterOptions.forEach(function (o) {
            if (o.isSelected) {
                qaCodes.push(o.value);
            }
        });
        return qaCodes;
    };
    // Get all schema data
    MainDataService.prototype.getSchemaData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var layer, randomId, rsp, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layer = this.activityService.selectedLayerBS.getValue().layer;
                        if (!layer) {
                            return [2 /*return*/];
                        }
                        randomId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, randomId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.qcService.getQcSchemaReport(layer.id)];
                    case 2:
                        rsp = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, randomId);
                        this.schemaDataBS.next({
                            layerId: layer.id,
                            data: rsp.data
                        });
                        return [2 /*return*/, rsp];
                }
            });
        });
    };
    MainDataService.prototype.getTooltipFromQaNotes = function (notes, col) {
        var tooltip = '';
        if (notes && notes[col]) {
            notes[col].forEach(function (i, idx) {
                if (i.msg) {
                    tooltip += i.msg + (idx === notes[col].length - 1 ? '' : '\n');
                }
            });
        }
        return tooltip;
    };
    MainDataService.prototype.getTooltipFromSchemaNotes = function (notes) {
        var tooltip = '';
        if (notes) {
            notes.forEach(function (i, idx) {
                if (i.msg) {
                    tooltip += i.msg + (idx === notes.length - 1 ? '' : '\n');
                }
            });
        }
        return tooltip;
    };
    MainDataService.prototype.getSchemaDefinedBy = function () {
        return [
            {
                name: 'NENA',
                value: 'standard',
                columnsMappingByLayer: {}
            }, {
                name: 'LOCAL',
                value: 'local',
                columnsMappingByLayer: {}
            }, {
                name: 'STATE',
                value: 'state',
                columnsMappingByLayer: {}
            }
        ];
    };
    // Transform rows to extract data of attr columns in nstd/state columns
    MainDataService.prototype.transformJsonData = function (type, rows, schemaDefinedBys, isAddColumns, layerId) {
        var _this = this;
        var endWithStr = type === 'nstd' ? this.attrIndexService.jsonbColumnEnd : this.attrIndexService.jsonbColumnEnd_state;
        // Get the column that stores nstd
        var keyCol = Object.keys(rows[0]).find(function (col) {
            return col.endsWith(endWithStr);
        });
        var colsByProp = {};
        if (keyCol) {
            rows.forEach(function (r) {
                if (r[keyCol]) {
                    for (var _i = 0, _a = Object.keys(r[keyCol]); _i < _a.length; _i++) {
                        var attr = _a[_i];
                        r[attr] = r[keyCol][attr];
                        if (!colsByProp[attr]) {
                            colsByProp[attr] = _this.tableService.setNewColumn(attr);
                        }
                    }
                }
            });
            // Add attr columns to local schema
            if (isAddColumns) {
                var targetSchema = void 0;
                switch (type) {
                    case 'nstd':
                        targetSchema = schemaDefinedBys.find(function (d) { return d.value === 'local'; });
                        break;
                    case 'state': targetSchema = schemaDefinedBys.find(function (d) { return d.value === 'state'; });
                }
                var columns = targetSchema.columnsMappingByLayer[layerId];
                columns = columns.concat(Object.keys(colsByProp).map(function (k) {
                    return colsByProp[k];
                }));
                targetSchema.columnsMappingByLayer[layerId] = columns;
            }
        }
    };
    // Transform rows to extract data of attr columns in nstd/state columns
    MainDataService.prototype.unpackJsonbData_myLayers = function (type, rows, schemas, isAddColumns) {
        var endWithStr = type === 'nstd' ? this.attrIndexService.jsonbColumnEnd : this.attrIndexService.jsonbColumnEnd_state;
        // Get the column that stores nstd
        var keyCol = Object.keys(rows[0]).find(function (col) {
            return col.endsWith(endWithStr);
        });
        if (keyCol) {
            var colsByProp_1 = this.unpackJsonbIntoRows(rows, keyCol);
            // Add attr columns to local schema
            if (isAddColumns) {
                var columns_1 = type === 'state' ? schemas.state : schemas.local;
                Object.keys(colsByProp_1).map(function (k) {
                    return colsByProp_1[k];
                }).forEach(function (c) { return columns_1.push(c); });
            }
        }
    };
    MainDataService.prototype.unpackJsonbData_collaborative = function (rows, columns) {
        if (!rows || !rows.length) {
            return;
        }
        var endWithStr = this.attrIndexService.jsonbColumnEnd;
        // Get the column that stores nstd
        var keyCol = Object.keys(rows[0]).find(function (col) {
            return col.endsWith(endWithStr);
        });
        if (keyCol) {
            var colsByProp_2 = this.unpackJsonbIntoRows(rows, keyCol);
            if (!Object.keys(colsByProp_2).length) {
                return;
            }
            var jsonbColIdx = columns.findIndex(function (c) { return c.prop.endsWith(endWithStr); });
            // If jsonbCol hasn't been removed from columns, it means it's the first time to unpack jsonb
            // In this case, remove jsonb col and add unpacked cols
            if (jsonbColIdx > -1) {
                // remove
                columns.splice(jsonbColIdx, 1);
                // Add attr columns to local schema
                Object.keys(colsByProp_2).map(function (k) {
                    return colsByProp_2[k];
                }).forEach(function (c) { return columns.push(c); });
            }
        }
    };
    MainDataService.prototype.unpackJsonbIntoRows = function (rows, jsonbCol) {
        var _this = this;
        // columns unpacked from jsonb
        var colsByProp = {};
        rows.forEach(function (r) {
            if (r[jsonbCol]) {
                for (var _i = 0, _a = Object.keys(r[jsonbCol]); _i < _a.length; _i++) {
                    var attr = _a[_i];
                    r[attr] = r[jsonbCol][attr];
                    if (!colsByProp[attr]) {
                        colsByProp[attr] = _this.tableService.setNewColumn(attr);
                        colsByProp[attr].info.isJsonbCol = true;
                        // colsByProp[attr].info.jsonbType = type;
                    }
                }
            }
        });
        return colsByProp;
    };
    // Add card to editCardList
    // Use this OUTSIDE edit-card component (inside edit-card component please use addCardToList)
    MainDataService.prototype.addRecToCard = function (recId, layerCateCode, source, isDelete, isHold) {
        var attrs = this.getDataAttrs(recId);
        if (!attrs[this.attrIndexService.isEditedKey]) { //  && !attrs[this.attrIndexService.isDeletedKey]
            if (isDelete) {
                this.setDataAttrs(recId, this.attrIndexService.isDeletedKey, true);
            }
            else {
                this.setDataAttrs(recId, this.attrIndexService.isEditedKey, true);
            }
            // For provBdry, check discrepancyId
            if (layerCateCode && layerCateCode === this.attrIndexService.cateCodeProvBdry) {
                var prefix = this.appinfoService.layerTypeList.find(function (t) { return t.code === layerCateCode; }).colPrefix;
                var discrepancyAgencyIdColName = prefix + this.attrIndexService.discrepancyAgencyIdStandardLower;
                if (attrs[discrepancyAgencyIdColName] !== this.appinfoService.customerProfile.discrepancyAgencyId) {
                    var hiddenIds = this.activityService.editRecordListHiddenBS.getValue().ids;
                    hiddenIds.push(recId);
                    this.activityService.editRecordListHiddenBS.next({
                        ids: hiddenIds,
                        source: 'main'
                    });
                    return;
                }
            }
            if (!isHold) {
                var editedIds = this.activityService.editRecordListBS.getValue().ids;
                if (editedIds.indexOf(recId) === -1) {
                    editedIds.push(recId);
                    this.activityService.editRecordListBS.next({
                        ids: editedIds,
                        source: source || 'main'
                    });
                }
            }
            else {
                var editedIds = this.activityService.editRecordHoldListBS.getValue().ids;
                if (editedIds.indexOf(recId) === -1) {
                    editedIds.push(recId);
                    this.activityService.editRecordHoldListBS.next({
                        ids: editedIds,
                        source: source
                    });
                }
            }
        }
    };
    MainDataService.prototype.addRecToHiddenList = function (recId) {
        var attrs = this.getDataAttrs(recId);
        // if (!attrs[this.attrIndexService.isEditedKey]) {
        // this.setDataAttrs(recId, this.attrIndexService.isEditedKey, true);
        var hiddenIds = this.activityService.editRecordListHiddenBS.getValue().ids;
        if (hiddenIds.indexOf(recId) === -1) {
            hiddenIds.push(recId);
            this.activityService.editRecordListHiddenBS.next({
                ids: hiddenIds
            });
        }
        // }
        return attrs;
    };
    // Add NEW record to card & table (no geom added)
    MainDataService.prototype.addNewCard = function (idCol, source, isHold) {
        var rec = {};
        rec[idCol] = this.commonService.getRandomId();
        rec[this.attrIndexService.isNewDataKey] = true;
        rec[this.attrIndexService.isEditedKey] = true;
        this.addDataToStoredRecords([rec], idCol, 'replace');
        if (!isHold) {
            var editedIds = this.activityService.editRecordListBS.getValue().ids;
            editedIds.push(rec[idCol]);
            this.activityService.editRecordListBS.next({
                ids: editedIds,
                source: source || 'main'
            });
        }
        else {
            var editedIds = this.activityService.editRecordHoldListBS.getValue().ids;
            editedIds.push(rec[idCol]);
            this.activityService.editRecordHoldListBS.next({
                ids: editedIds,
                source: source || 'main'
            });
        }
        return rec;
    };
    MainDataService.prototype.removeCard = function (id) {
        var editedIds = this.activityService.editRecordListBS.getValue().ids;
        var idx = editedIds.findIndex(function (i) { return i === id; });
        if (idx > -1) {
            editedIds.splice(idx, 1);
            this.activityService.editRecordListBS.next({
                ids: editedIds
            });
        }
    };
    // data should be original data
    // For parameter handlePrev: 
    //    'replace' means the data will completely replace what was in dataIndex; 
    //    'mergePrev' means keep both but properties in dataIndex will have higher priority; 
    //    'prev' means if dataIndex already has it, use dataIndex and ignore data 
    MainDataService.prototype.addDataToStoredRecords = function (data, idCol, handlePrev) {
        var _this = this;
        if (!data) {
            return;
        }
        handlePrev = handlePrev || 'mergeToPrev';
        data.forEach(function (i) {
            switch (handlePrev) {
                case 'replace':
                    _this.dataIndex[i[idCol]] = {
                        attrs: i,
                        originalAttrs: JSON.parse(JSON.stringify(i))
                    };
                    break;
                case 'mergeToPrev':
                    if (_this.dataIndex[i[idCol]]) {
                        _this.dataIndex[i[idCol]].originalAttrs = JSON.parse(JSON.stringify(i));
                        _this.dataIndex[i[idCol]].attrs = Object.assign(i, _this.dataIndex[i[idCol]].attrs);
                    }
                    else {
                        _this.dataIndex[i[idCol]] = {
                            attrs: i,
                            originalAttrs: JSON.parse(JSON.stringify(i))
                        };
                    }
                    break;
                case 'prev':
                    if (_this.dataIndex[i[idCol]]) {
                        return;
                    }
                    _this.dataIndex[i[idCol]] = {
                        attrs: i,
                        originalAttrs: JSON.parse(JSON.stringify(i))
                    };
                    break;
            }
        });
    };
    MainDataService.prototype.removeDataFromStoredRecords = function (id) {
        delete this.dataIndex[id];
    };
    MainDataService.prototype.replaceDataIndex = function (dataIndex) {
        this.dataIndex = dataIndex;
        this.dataIndexObjSubject.next();
    };
    MainDataService.prototype.getDataAttrs = function (id) {
        return this.dataIndex[id] ? this.dataIndex[id].attrs : null;
    };
    MainDataService.prototype.getDataOriginAttrs = function (id) {
        return this.dataIndex[id] ? this.dataIndex[id].originalAttrs : null;
    };
    MainDataService.prototype.setDataAttrs = function (id, prop, val) {
        if (!this.dataIndex[id]) {
            return;
        }
        this.dataIndex[id].attrs[prop] = val;
    };
    MainDataService.prototype.setDataOriginAttrs = function (id, prop, val) {
        if (!this.dataIndex[id]) {
            return;
        }
        this.dataIndex[id].originalAttrs[prop] = val;
    };
    MainDataService.prototype.clearDataChangeInIndex = function (id) {
        var origin = this.getDataOriginAttrs(id);
        if (!origin) { // if it's new card, discard it
            return;
        }
        var attrs = this.getDataAttrs(id);
        Object.keys(attrs).forEach(function (key) {
            if (origin[key] && typeof origin[key] === 'object') {
                attrs[key] = JSON.parse(JSON.stringify(origin[key]));
            }
            else {
                attrs[key] = origin[key];
            }
        });
    };
    MainDataService.prototype.getDataIndex = function () {
        return this.dataIndex;
    };
    MainDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainDataService_Factory() { return new MainDataService(i0.ɵɵinject(i1.CommonFunctionService), i0.ɵɵinject(i2.ActivityService), i0.ɵɵinject(i3.AppinfoService), i0.ɵɵinject(i4.AttrIndexService), i0.ɵɵinject(i5.LayerQcService), i0.ɵɵinject(i6.CommonModalService), i0.ɵɵinject(i7.CommonTableService), i0.ɵɵinject(i8.UserService)); }, token: MainDataService, providedIn: "root" });
    return MainDataService;
}());
export { MainDataService };
